export const NS_PRESENTATIONAL_BRICKS = "presentational-bricks";

export enum K {
  AGENT_STATUS_NORMAL = "AGENT_STATUS_NORMAL",
  AGENT_STATUS_ABNORMAL = "AGENT_STATUS_ABNORMAL",
  AGENT_STATUS_NOT_INSTALLED = "AGENT_STATUS_NOT_INSTALLED",
  AGENT_STATUS_UNINSTALLED = "AGENT_STATUS_UNINSTALLED",
  AGENT_STATUS_UNDER_MAINTENANCE = "AGENT_STATUS_UNDER_MAINTENANCE",
  ALERT_MSG_SENDED = "ALERT_MSG_SENDED",
  ALERT_CONVERGED = "ALERT_CONVERGED",
  ALERT_RECOVERED = "ALERT_RECOVERED",
  ALERT_MANUAL_RECOVERED = "ALERT_MANUAL_RECOVERED",
  ALERT_SHIELDED = "ALERT_SHIELDED",
  PRESENTATIONAL_BRICKS = "PRESENTATIONAL_BRICKS",
  PAGINATION_TOTAL_TEXT = "PAGINATION_TOTAL_TEXT",
  PAGINATION_TOTAL_UNIT = "PAGINATION_TOTAL_UNIT",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
  NO_DATA = "NO_DATA",
  COLLECTION_INSTANCE_SYNCHRONIZE = "COLLECTION_INSTANCE_SYNCHRONIZE",
  COLLECTION_INSTANCE_EXECUTE = "COLLECTION_INSTANCE_EXECUTE",
  DELETE = "DELETE",
  CROP_TITLE = "CROP_TITLE",
  COPY = "COPY",
  COPIED = "COPIED",
  COPY_FAILED = "COPY_FAILED",
  NO_TEXT_TO_COPY = "NO_TEXT_TO_COPY",
  CHOSEN_OPTIONS = "CHOSEN_OPTIONS",
  CLEAR = "CLEAR",
  SELECT_ALL = "SELECT_ALL",
  SELECTED = "SELECTED",
  ITEMS = "ITEMS",
  SELECTED_OPTIONS = "SELECTED_OPTIONS",
  FULL_TEXT_SEARCH = "FULL_TEXT_SEARCH",
  IP_SEARCH = "IP_SEARCH",
  SORT = "SORT",
  PREVIEW = "PREVIEW",
  NO_ALERT = "NO_ALERT",
  EDIT = "EDIT",
  COPY_CODE = "COPY_CODE",
  CODE_COPIED = "CODE_COPIED",
  CODE_COPY_FAILED = "CODE_COPY_FAILED",
  CLUSTER_TYPE_NONE = "CLUSTER_TYPE_NONE",
  CLUSTER_TYPE_DEVELOPMENT = "CLUSTER_TYPE_DEVELOPMENT",
  CLUSTER_TYPE_TEST = "CLUSTER_TYPE_TEST",
  CLUSTER_TYPE_PRODUCTION = "CLUSTER_TYPE_PRODUCTION",
  CLUSTER_TYPE_PRE_RELEASE = "CLUSTER_TYPE_PRE_RELEASE",
  PLEASE_ENTER_THE_SEARCH_CONTENT = "PLEASE_ENTER_THE_SEARCH_CONTENT",
  COUNT_ITEMS = "COUNT_ITEMS",
  EXPAND = "EXPAND",
  COLLAPSE = "COLLAPSE",
  TIP = "TIP",
  MAX_SELECTED_EXCEEDED = "MAX_SELECTED_EXCEEDED",
  GOT_IT = "GOT_IT",
  MAX_SELECT_COUNT = "MAX_SELECT_COUNT",
  ACTIONS = "ACTIONS",
  CONFIRM = "CONFIRM",
  CANCEL = "CANCEL",
  NO_SEARCH_RESULT = "NO_SEARCH_RESULT",
  ADD = "ADD",
  PLEASE_ADD_SERVICE_NODE = "PLEASE_ADD_SERVICE_NODE",
  NOTICE = "NOTICE",
  WARNING = "WARNING",
  URGENT = "URGENT",
  DATASOURCE_EMPTY_ERROR = "DATASOURCE_EMPTY_ERROR",
  DELETE_CONFIRM_MESSAGE = "DELETE_CONFIRM_MESSAGE",
  DELETE_CONFIRM_DETAIL = "DELETE_CONFIRM_DETAIL",
  DELETE_CONFIRM_INPUT_HINT = "DELETE_CONFIRM_INPUT_HINT",
}

export type Locale = { [key in K]: string };
